import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';

import { GeneralMeetingCheckInService } from './general-meeting-check-in.service';
import { UserSessionService } from './user-session.service';

/**
 * Reusable business logic which we don't want to have in the components.
 */
@Injectable({
    providedIn: 'root'
})
export class SharedBusinessLogicService {
    readonly onReloadDeliveryInformation = new Subject<void>();

    private readonly generalMeetingCheckinService = inject(GeneralMeetingCheckInService);
    private readonly userSessionService = inject(UserSessionService);

    isBussinesShareholder(shareholderTypeId: string): boolean {
        // only  legal person (JUR) or single company (EIN):
        return shareholderTypeId === 'JUR' || shareholderTypeId === 'EIN';
    }

    reloadDeliveryInformation(): void {
        this.onReloadDeliveryInformation.next();
    }

    /**
     * If user is checked in to the meeting and is a Netvote user, we check out.
     */
    checkOutFromMeeting(): void {
        this.generalMeetingCheckinService.getStatus().subscribe(isCheckedIn => {
            if (isCheckedIn && this.userSessionService.hasNetvoteRole) {
                this.generalMeetingCheckinService.checkOut();
            }
        });
    }
}
